<div *ngIf="workspacesCount <= 0">Unauthorised to manage any workspace</div>
<router-outlet></router-outlet>
